import styled from 'styled-components';

export const HelpContainer = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const HelpContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HelpSection = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid ${(props) => props.theme.tokens.color.border.primary};

  &:last-child {
    border-bottom: none;
  }
`;

